__turbopack_context__.v({
  "className": "inter_7fadf378-module__b18sIq__className",
  "variable": "inter_7fadf378-module__b18sIq__variable",
});
